import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const Container = styled(Flex)`
  padding: 20px 25px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  background-color: #fafafb;
  z-index: 99;
  position: sticky !important;
  top: 0 !important;
`
export const Main = styled.div`
  position: sticky;
  top: 0;
  z-index: 1001;
`
export const LeftSection = styled(Flex)`
  gap: 20px;
`
export const RightSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`
